// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.J45Fo5Y9pDTbSGQeyLxK{list-style:none;width:100%}._YhqvEFo1_1v1dOA1THx{margin:0 auto}`, "",{"version":3,"sources":["webpack://./services/client/src/components/ReportedSiteList/styles.module.scss"],"names":[],"mappings":"AAEA,sBACE,eAAA,CACA,UAAA,CAEF,sBACE,aAAA","sourcesContent":["@import '../../styles/global.scss';\n\n.list {\n  list-style: none;\n  width: 100%;\n}\n.load-more {\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `J45Fo5Y9pDTbSGQeyLxK`,
	"load-more": `_YhqvEFo1_1v1dOA1THx`
};
export default ___CSS_LOADER_EXPORT___;
